// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  display: flex;
  min-height: 100vh;
  background: var(--bg);
}

.auth-aside {
  display: none;
  flex-direction: column;
  width: 42%;
  max-width: 520px;
  padding: 40px;
  background: var(--grad-deep);
  color: #fff;
}

.auth-aside-brand {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  margin-bottom: auto;
  padding: 10px 14px;
  background: #fff;
  border-radius: 14px;
}

.auth-aside-brand img {
  height: 52px;
  width: auto;
  display: block;
}

.auth-aside h2 {
  font-size: 1.9rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 26px;
}

.auth-aside ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.auth-aside li {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  font-size: 0.92rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.86);
}

.auth-aside li svg {
  flex-shrink: 0;
  margin-top: 3px;
  color: #fff;
}

.auth-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 30px 20px 44px;
}

.auth-panel-brand {
  display: block;
}

.auth-panel-brand img {
  height: 48px;
  width: auto;
  display: block;
}

.auth-card {
  width: 100%;
  max-width: 440px;
  padding: 28px 24px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
}

.auth-card h1 {
  font-size: 1.5rem;
  font-weight: 800;
  margin-bottom: 6px;
}

.auth-sub {
  color: var(--muted);
  font-size: 0.92rem;
  line-height: 1.6;
  margin-bottom: 20px;
}

.auth-foot {
  font-size: 0.9rem;
  color: var(--muted);
  text-align: center;
}

.auth-foot a {
  color: var(--brand);
  font-weight: 600;
  text-decoration: none;
}

.auth-foot a:hover {
  text-decoration: underline;
}

@media (min-width: 900px) {
  .auth-aside {
    display: flex;
  }

  .auth-panel-brand {
    display: none;
  }

  .auth-card {
    padding: 34px 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/auth/AuthShell.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".auth-page {\n  display: flex;\n  min-height: 100vh;\n  background: var(--bg);\n}\n\n.auth-aside {\n  display: none;\n  flex-direction: column;\n  width: 42%;\n  max-width: 520px;\n  padding: 40px;\n  background: var(--grad-deep);\n  color: #fff;\n}\n\n.auth-aside-brand {\n  display: inline-flex;\n  align-self: flex-start;\n  align-items: center;\n  margin-bottom: auto;\n  padding: 10px 14px;\n  background: #fff;\n  border-radius: 14px;\n}\n\n.auth-aside-brand img {\n  height: 52px;\n  width: auto;\n  display: block;\n}\n\n.auth-aside h2 {\n  font-size: 1.9rem;\n  font-weight: 800;\n  line-height: 1.2;\n  margin-bottom: 26px;\n}\n\n.auth-aside ul {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.auth-aside li {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n  font-size: 0.92rem;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.86);\n}\n\n.auth-aside li svg {\n  flex-shrink: 0;\n  margin-top: 3px;\n  color: #fff;\n}\n\n.auth-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  padding: 30px 20px 44px;\n}\n\n.auth-panel-brand {\n  display: block;\n}\n\n.auth-panel-brand img {\n  height: 48px;\n  width: auto;\n  display: block;\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 440px;\n  padding: 28px 24px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n}\n\n.auth-card h1 {\n  font-size: 1.5rem;\n  font-weight: 800;\n  margin-bottom: 6px;\n}\n\n.auth-sub {\n  color: var(--muted);\n  font-size: 0.92rem;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.auth-foot {\n  font-size: 0.9rem;\n  color: var(--muted);\n  text-align: center;\n}\n\n.auth-foot a {\n  color: var(--brand);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.auth-foot a:hover {\n  text-decoration: underline;\n}\n\n@media (min-width: 900px) {\n  .auth-aside {\n    display: flex;\n  }\n\n  .auth-panel-brand {\n    display: none;\n  }\n\n  .auth-card {\n    padding: 34px 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
